import React, { useEffect, useState } from 'react';
import { useNavigate } from '../nav';
import { AVAILABLE_BALANCE, ACCOUNT_NAME, VE_BANK_ASSETS } from '../lib/brand';
import { BottomNav } from '../components/BottomNav';
import { CustomIcon } from '../components/CustomIcons';
import { VeeMascot } from '../components/VeeMascot';
const actions = [{
  label: 'Send',
  icon: VE_BANK_ASSETS.actionSend,
  path: '/transfer',
  aria: 'Send money'
}, {
  label: 'Airtime',
  icon: VE_BANK_ASSETS.actionAirtime,
  path: '/draft?bill=Airtime',
  aria: 'Buy airtime'
}, {
  label: 'Bills',
  icon: VE_BANK_ASSETS.actionBills,
  path: '/bills',
  aria: 'Pay bills'
}, {
  label: 'Card',
  icon: VE_BANK_ASSETS.actionCards,
  path: '/account',
  aria: 'Manage cards'
}];
const defaultFavourites = ['Send', 'Airtime', 'Bills'];
export function Home() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<'voice' | 'text'>('voice');
  const [favourites, setFavourites] = useState<string[]>(() => {
    try {
      return JSON.parse(window.localStorage.getItem('ve-favourites') || 'null') || defaultFavourites;
    } catch {
      return defaultFavourites;
    }
  });
  const [notice, setNotice] = useState('');
  useEffect(() => {
    window.localStorage.setItem('ve-favourites', JSON.stringify(favourites));
  }, [favourites]);
  const flash = (message: string) => {
    setNotice(message);
    window.setTimeout(() => setNotice(''), 1800);
  };
  return <main className="flex min-h-full w-full flex-col bg-brand-cloud" data-id="element-401" data-mp="2hxx9z6cuquyu">
      {/* Account surface — balance and cash flow, sized to support the assistant rather than compete with it. */}
      <section className="relative shrink-0 overflow-hidden bg-[#061827] px-5 pb-14 pt-12 text-white" data-id="element-402" data-mp="2d548qsgle4ri">
        <div aria-hidden="true" className="absolute -right-14 top-6 h-44 w-44 rounded-full bg-brand-purple/45 blur-3xl" data-id="element-403" data-mp="285rjk1290llr" />
        <header className="relative flex items-center justify-between" data-id="element-404" data-mp="1z764ifvzjopq">
          <div className="flex items-center gap-2" data-id="element-405" data-mp="1z98syvhhp9sc">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white" data-id="element-406" data-mp="1u9e3mwdd4s9e">
              <img src={VE_BANK_ASSETS.appIcon} alt="" className="h-6 w-6 object-contain" data-id="element-407" data-mp="1kkh4mcxtn9it" />
            </span>
            <span className="text-sm font-extrabold" data-id="element-408" data-mp="1ondm20bmkzl6">Good afternoon, Chidi</span>
          </div>
          <button onClick={() => navigate('/profile')} aria-label="Open profile" className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10" data-id="element-409" data-mp="1ankvq640gldq">
            <CustomIcon name="profile" size={18} data-id="element-410" data-mp="23b8fxk1dd9zu" />
          </button>
        </header>

        <button onClick={() => navigate('/account')} className="relative mt-6 w-full text-left" data-id="element-411" data-mp="23dkt7jw6mw6k">
          <div className="flex items-end justify-between" data-id="element-412" data-mp="28c4dzgz1i1xc">
            <div data-id="element-413" data-mp="1tkm4m20or5my">
              <p className="text-[11px] font-bold uppercase tracking-[.15em] text-blue-200" data-id="element-414" data-mp="1tl5b8mkvy7lo">{ACCOUNT_NAME}</p>
              <h1 className="mt-2 text-[34px] font-extrabold tracking-[-.06em] tabular-nums" data-id="element-415" data-mp="1yif7al2s5hih">{AVAILABLE_BALANCE}</h1>
              <p className="mt-1 text-xs text-slate-300" data-id="element-416" data-mp="2r0syi1tm258l">Available to use</p>
            </div>
            <span className="rounded-full bg-white/10 px-3 py-1.5 text-[10px] font-extrabold text-blue-100" data-id="element-417" data-mp="2r2m2tagr4ddf">VERIFIED</span>
          </div>
          <div className="mt-5 flex h-10 items-end gap-1.5 border-t border-white/10 pt-3" data-id="element-418" data-mp="anipolqznhwf">
            {[28, 42, 24, 54, 32, 67, 38, 76, 49, 89, 54, 72].map((height, index) => <span key={index} className="data-shift w-full rounded-t-sm bg-[linear-gradient(180deg,#0EA5FF,#6747E8)] opacity-80" style={{
            height: `${height}%`,
            animationDelay: `${index * 80}ms`
          }} data-id="element-419" data-mp="kc0o4wbspcww" data-mpi={index} />)}
          </div>
          <div className="mt-2 flex justify-between text-[10px] font-bold text-slate-400" data-id="element-420" data-mp="3nukj46luywve">
            <span data-id="element-421" data-mp="5opc6tbpbqw9">Cash flow · 7 days</span>
            <span data-id="element-422" data-mp="5ljqzp67195t">+₦18,420 in</span>
          </div>
        </button>
      </section>

      <section className="relative -mt-10 shrink-0 space-y-5 px-5 pb-5" data-id="element-423" data-mp="n8d93cs2eib">
        {/* Signature surface: the assistant leads the screen. */}
        <section className="relative overflow-hidden rounded-[30px] bg-[linear-gradient(135deg,#10294a,#246BFE_56%,#6747E8)] p-6 text-white shadow-float" data-id="element-424" data-mp="1c3yo4zs5bui9">
          <div aria-hidden="true" className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-brand-electric/30 blur-2xl" data-id="element-425" data-mp="27fpsm761037g" />
          <div className="relative flex items-center justify-between" data-id="element-426" data-mp="2hc2l51pu4b0m">
            <div className="flex items-center gap-3" data-id="element-427" data-mp="2hargkzokez8g">
              <VeeMascot size={44} state={mode === 'voice' ? 'listening' : 'speaking'} decorative data-id="element-428" data-mp="2mbp13ix1s5d4" />
              <p className="flex items-center gap-2 text-base font-extrabold" data-id="element-429" data-mp="2qdiwpcsdyj6f">
                Ask Vee
                <span aria-hidden="true" className="vee-status h-1.5 w-1.5 rounded-full bg-brand-electric" data-id="element-430" data-mp="2vb28m61m2jv7" />
              </p>
            </div>
            <div className="flex shrink-0 rounded-xl bg-black/20 p-1" role="tablist" aria-label="Vee input mode" data-id="element-431" data-mp="303c4e2peqe5e">
              <button role="tab" aria-selected={mode === 'voice'} onClick={() => setMode('voice')} className={`rounded-lg px-2.5 py-1 text-[10px] font-extrabold ${mode === 'voice' ? 'bg-white text-brand-navy' : 'text-blue-100'}`} data-id="element-432" data-mp="353hql3cwr8g3">VOICE</button>
              <button role="tab" aria-selected={mode === 'text'} onClick={() => setMode('text')} className={`rounded-lg px-2.5 py-1 text-[10px] font-extrabold ${mode === 'text' ? 'bg-white text-brand-navy' : 'text-blue-100'}`} data-id="element-433" data-mp="12g1c2l4k7xl1">TEXT</button>
            </div>
          </div>

          <button onClick={() => navigate(`/chat?mode=${mode}`)} className="relative mt-5 flex min-h-[56px] w-full items-center justify-between rounded-2xl bg-white/12 px-5 text-left text-sm font-bold backdrop-blur" data-id="element-434" data-mp="ofgu1r6gy5sl">
            <span className="flex items-center gap-3" data-id="element-435" data-mp="1h3mcu8dypkps">
              {mode === 'voice' && <span aria-hidden="true" className="flex items-end gap-0.5" data-id="element-436" data-mp="1ccmklgfsfqtm">
                  {[9, 15, 7, 13].map((height, index) => <span key={index} className="data-shift w-0.5 rounded-full bg-brand-electric" style={{
                height,
                animationDelay: `${index * 110}ms`
              }} data-id="element-437" data-mp="17djl0bikuct1" data-mpi={index} />)}
                </span>}
              {mode === 'voice' ? 'Tap to speak to Vee' : 'Ask Vee to prepare something'}
            </span>
            <span aria-hidden="true" className="text-brand-electric" data-id="element-438" data-mp="3ucyg8gi0bwhv">↗</span>
          </button>
        </section>

        {/* Vee's proactive insight, delivered before any setup request. */}
        <section className="rounded-[25px] bg-white p-5 shadow-soft" data-id="element-439" data-mp="3kioon10w3287">
          <div className="flex items-start gap-3" data-id="element-440" data-mp="3piksn09l6tnr">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-brand-cobalt" data-id="element-441" data-mp="3amlbz18evl70">
              <CustomIcon name="spark" size={18} data-id="element-442" data-mp="3fly9qh0tmcod" />
            </span>
            <div data-id="element-443" data-mp="31lwws37a7esj">
              <p className="text-sm font-extrabold text-brand-navy" data-id="element-444" data-mp="31mgfvn8o4985">Vee noticed</p>
              <p className="mt-1 text-xs leading-relaxed text-brand-slate" data-id="element-445" data-mp="36l045uaqhx3o">You have ₦160,000 left in today’s transfer limit. Your electricity payment is due in 4 days.</p>
              <button onClick={() => navigate('/chat')} className="mt-3 min-h-[44px] text-[11px] font-extrabold text-brand-cobalt" data-id="element-446" data-mp="zvbn2nv012m8">Ask Vee about this</button>
            </div>
          </div>
        </section>

        <section data-id="element-447" data-mp="1evh9w5mtv2wd">
          <div className="mb-3 flex items-center justify-between" data-id="element-448" data-mp="19yh3ftm2fy4q">
            <h2 className="text-sm font-extrabold text-brand-navy" data-id="element-449" data-mp="1a0bln05ydc54">Manual actions</h2>
            <button onClick={() => navigate('/account')} className="min-h-[44px] text-[11px] font-extrabold text-brand-cobalt" data-id="element-450" data-mp="1nrgg7nugre8l">Manage account</button>
          </div>
          <div className="grid grid-cols-4 gap-2" data-id="element-451" data-mp="1xnjpddnqgd51">
            {actions.map(action => <div key={action.label} className="relative" data-id="element-452" data-mp="1sphwy24f31gw">
                <button onClick={() => navigate(action.path)} aria-label={action.aria} className="group flex min-h-[60px] w-full flex-col items-center justify-center gap-1.5 rounded-[16px] bg-white py-2 text-brand-navy shadow-soft transition-all duration-150 hover:-translate-y-[1px] hover:scale-[1.01] hover:bg-slate-50 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-4 focus-visible:outline-brand-cobalt active:scale-[1.01] active:bg-slate-50 motion-reduce:transition-none motion-reduce:hover:translate-y-0 motion-reduce:hover:scale-100 motion-reduce:active:scale-100" data-id="element-453" data-mp="1sr2r3qmtkie8">
                  <img src={action.icon} alt="" className="h-[24px] w-[24px] sm:h-[28px] sm:w-[28px]" data-id="element-454" data-mp="16kejp9xi6jt0" />
                  <span className="text-[9px] font-extrabold" data-id="element-455" data-mp="1akyh8elznpfo">{action.label}</span>
                </button>
                <button onClick={() => editFavourite(action.label)} aria-label={`${favourites.includes(action.label) ? 'Remove' : 'Add'} ${action.label} favourite`} className={`absolute right-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-full text-[10px] leading-none transition-colors ${favourites.includes(action.label) ? 'bg-brand-cobalt text-white' : 'bg-slate-100 text-brand-slate hover:bg-slate-200'}`} data-id="element-456" data-mp="dx1wqynfk9z6">
                  {favourites.includes(action.label) ? '–' : '+'}
                </button>
              </div>)}
          </div>
        </section>

        {notice && <p role="status" className="rounded-xl bg-blue-50 px-3 py-2 text-center text-[10px] font-extrabold text-brand-cobalt" data-id="element-457" data-mp="28epqg4ehnynl">{notice}</p>}
      </section>

      <BottomNav data-id="element-458" data-mp="23lwk5c3dgi9e" />
    </main>;
}